// Recovered compiled webpack factory 6500. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { l: () => n });
  let n = (t) => t;
}
